export default function MuscleMap({ primaryMuscles = [], secondaryMuscles = [], onMuscleClick }) {
  const getColor = (muscle) => {
    const lc = muscle.toLowerCase();
    if (primaryMuscles.some((m) => lc.includes(m.toLowerCase()) || m.toLowerCase().includes(lc))) {
      return { fill: 'rgba(232,255,71,0.35)', stroke: '#E8FF47' };
    }
    if (secondaryMuscles.some((m) => lc.includes(m.toLowerCase()) || m.toLowerCase().includes(lc))) {
      return { fill: 'rgba(255,107,53,0.25)', stroke: '#FF6B35' };
    }
    return { fill: 'rgba(255,255,255,0.04)', stroke: 'rgba(255,255,255,0.12)' };
  };

  const frontMuscles = [
    { muscle: 'chest', x: 80, y: 92, w: 60, h: 40 },
    { muscle: 'core', x: 85, y: 138, w: 50, h: 55 },
    { muscle: 'shoulders', x: 48, y: 84, w: 26, h: 28 },
    { muscle: 'biceps', x: 44, y: 115, w: 25, h: 40 },
    { muscle: 'quadriceps', x: 84, y: 222, w: 40, h: 80 },
    { muscle: 'quadriceps', x: 96, y: 222, w: 40, h: 80 },
    { muscle: 'calves', x: 86, y: 350, w: 34, h: 60 },
  ];

  const backMuscles = [
    { muscle: 'upper back', x: 80, y: 88, w: 60, h: 45 },
    { muscle: 'lats', x: 76, y: 130, w: 28, h: 55 },
    { muscle: 'lats', x: 116, y: 130, w: 28, h: 55 },
    { muscle: 'triceps', x: 150, y: 115, w: 24, h: 40 },
    { muscle: 'triceps', x: 46, y: 115, w: 24, h: 40 },
    { muscle: 'glutes', x: 82, y: 220, w: 56, h: 38 },
    { muscle: 'hamstrings', x: 84, y: 260, w: 40, h: 75 },
    { muscle: 'hamstrings', x: 96, y: 260, w: 40, h: 75 },
    { muscle: 'calves', x: 86, y: 350, w: 34, h: 60 },
  ];

  const bodySilhouette = (
    <>
      <ellipse cx="110" cy="45" rx="32" ry="38" fill="#1C1C1F" stroke="rgba(255,255,255,0.1)" strokeWidth="1.5" />
      <rect x="74" y="78" width="72" height="140" rx="12" fill="#1C1C1F" stroke="rgba(255,255,255,0.1)" strokeWidth="1.5" />
      <rect x="42" y="84" width="30" height="110" rx="10" fill="#1C1C1F" stroke="rgba(255,255,255,0.1)" strokeWidth="1.5" />
      <rect x="148" y="84" width="30" height="110" rx="10" fill="#1C1C1F" stroke="rgba(255,255,255,0.1)" strokeWidth="1.5" />
      <rect x="82" y="218" width="46" height="130" rx="10" fill="#1C1C1F" stroke="rgba(255,255,255,0.1)" strokeWidth="1.5" />
      <rect x="110" y="218" width="46" height="130" rx="10" fill="#1C1C1F" stroke="rgba(255,255,255,0.1)" strokeWidth="1.5" />
      <rect x="84" y="348" width="40" height="80" rx="8" fill="#1C1C1F" stroke="rgba(255,255,255,0.1)" strokeWidth="1.5" />
      <rect x="96" y="348" width="40" height="80" rx="8" fill="#1C1C1F" stroke="rgba(255,255,255,0.1)" strokeWidth="1.5" />
    </>
  );

  return (
    <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.3)', marginBottom: 6 }}>FRONT</div>
        <svg width="160" height="440" viewBox="0 0 220 440" style={{ display: 'block' }}>
          {bodySilhouette}
          {frontMuscles.map(({ muscle, x, y, w, h }) => {
            const c = getColor(muscle);
            return (
              <rect
                key={`${muscle}-${x}`}
                x={x}
                y={y}
                width={w}
                height={h}
                rx={6}
                fill={c.fill}
                stroke={c.stroke}
                strokeWidth="1"
                style={{ cursor: 'pointer', transition: 'fill 0.2s' }}
                onClick={() => onMuscleClick?.(muscle)}
              />
            );
          })}
        </svg>
      </div>

      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.3)', marginBottom: 6 }}>BACK</div>
        <svg width="160" height="440" viewBox="0 0 220 440" style={{ display: 'block' }}>
          {bodySilhouette}
          {backMuscles.map(({ muscle, x, y, w, h }) => {
            const c = getColor(muscle);
            return (
              <rect
                key={`b-${muscle}-${x}`}
                x={x}
                y={y}
                width={w}
                height={h}
                rx={6}
                fill={c.fill}
                stroke={c.stroke}
                strokeWidth="1"
                style={{ cursor: 'pointer', transition: 'fill 0.2s' }}
                onClick={() => onMuscleClick?.(muscle)}
              />
            );
          })}
        </svg>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 10 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <div style={{ width: 12, height: 12, borderRadius: 3, background: 'rgba(232,255,71,0.35)', border: '1px solid #E8FF47' }} />
          <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.5)' }}>Primary</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <div style={{ width: 12, height: 12, borderRadius: 3, background: 'rgba(255,107,53,0.25)', border: '1px solid #FF6B35' }} />
          <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.5)' }}>Secondary</span>
        </div>
      </div>
    </div>
  );
}
